module.exports = __webpack_public_path__ + "static/img/operation.edab3038.png";